import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import Link from "next/link";
import Slider from "react-slick";
import Article from "../Articles/Article";
import useWindowWidth from "hooks/useWindowWidth";
import { PrevArrow } from "./assets/arrow_prev.svg";
import { NextArrow } from "./assets/arrow_next.svg";

export default function Featured({ articles = [] }) {
  const width = useWindowWidth();
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  const nextSlide = () => {
    if (currentSlide === articles.length - 3) {
      setCurrentSlide(0);
    } else {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide - 1);
  };

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(
        currentSlide,
        currentSlide === 0 || currentSlide === articles.length - 1
      );
    }
  }, [currentSlide]);

  const settings = {
    dots: true,
    dotsClass: `slick-dots slick-thumb ${styles.dots}`,
    appendDots: (dots) => {
      return (
        <div>
          <ul style={{ margin: "0px" }}> {dots} </ul>
        </div>
      );
    },
    arrows: false,
    infinite: true,
    slidesToShow: width > 1300 ? 3 : width > 900 ? 2 : 1,
    slidesToScroll: 1,
    speed: 500,
    afterChange: (current) => setCurrentSlide(current),
  };

  return (
    <div className={styles.wrapper}>
      <div className="container">
        {width > 900 && (
          <div className={styles.header}>
            <div className={styles.title}>
              Featured collection for the app growth
            </div>

            <div className={styles.buttons}>
              <div className={styles.prevButton} onClick={prevSlide}>
                <PrevArrow />
              </div>
              <div className={styles.nextButton} onClick={nextSlide}>
                <NextArrow />
              </div>
            </div>
          </div>
        )}

        <Slider className={styles.slider} ref={sliderRef} {...settings}>
          {Array.isArray(articles) &&
            articles.map((article, i) => {
              return (
                <div
                  className={styles.elem}
                  key={`${article.title}-${article.identifier}`}
                >
                  <Link href={`/blog/${article.identifier}`}>
                    <a>
                      <Article
                        color={article.color}
                        readingTime={
                          article.reading_time || article.readingTime
                        }
                        image={article?.icon?.thumb || article.image}
                        title={article.title}
                        description={article.pretext || article.description}
                        avatar={article.user?.avatar.thumb || article.avatar}
                        author={
                          article.user?.first_name
                            ? `${article.user?.first_name} ${article.user?.last_name}`
                            : article.author
                        }
                        created={
                          article.published_at ||
                          article.created_at ||
                          article.created
                        }
                      />
                    </a>
                  </Link>
                </div>
              );
            })}
        </Slider>
      </div>
    </div>
  );
}
